import React, { memo } from "react"
import { Link } from "react-router-dom"

import { Box, Text } from "@mos-cat/ds"
import { Avatar, CustomGetUsersOptionLabel } from "@dit/core-frontend"
import { ROUTES } from "@constants"

export const Person = memo(
  ({
    person,
    avatarSize = 20,
    textMaxWidth = "250px",
    isProfileLink = false,
    innerBoxDisplay = "-webkit-box",
    ...boxProps
  }) => {
    return (
      <Text
        as={Box}
        display="flex"
        alignItems="flex-start"
        gridGap="10px"
        color="inherit"
        fontSize="inherit"
        {...boxProps}
      >
        <Avatar url={person?.photo?.url || person?.photo} size={avatarSize} />
        <Text
          as={Box}
          maxWidth={textMaxWidth}
          styles={{
            display: innerBoxDisplay,
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": "2",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {isProfileLink ? (
            <Link to={`/${ROUTES.PROFILE}/${person?.id}`}>{CustomGetUsersOptionLabel(person)}</Link>
          ) : (
            <Text>{CustomGetUsersOptionLabel(person)}</Text>
          )}
        </Text>
      </Text>
    )
  },
)

Person.displayName = "Person"
